import { avrSettingAPI } from "@/views/AvrSetting/services/api";

export const getAvrSettings = async () => {
  try {
    const res = await avrSettingAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const updateAvrSetting = async (body = {}) => {
  try {
    const res = await avrSettingAPI.update(body);
    return res?.data;
  } catch (e) {}
};

export const avrSettingColumns = [
  {
    name: "constructive_name",
    field: "constructive_name",
    label: "Конструктив",
    align: "left",
  },
  {
    name: "avr_day",
    field: "avr_day",
    label: "День месяца",
    align: "center",
  },
  {
    name: "avr_percent",
    field: "avr_percent",
    label: "Процент",
    align: "center",
  },
  { 
    name: "edit", 
    field: "edit", 
    label: "Действия", 
    align: "center" 
  },
];
